export enum DateRange {
    Past,
    Inmediate
}